import store from '../store/store';
import NavBarData from 'owa-service/lib/contract/NavBarData';
import { action } from 'satcheljs';
import { mutator } from 'satcheljs';

export const setBposNavBarData = action('SET_BPOS_NAV_BAR_DATA ', (bposNavBarData: NavBarData) => ({
    bposNavBarData: bposNavBarData,
}));

mutator(setBposNavBarData, actionMessage => {
    store.bposNavBarData = actionMessage.bposNavBarData;
});
